import { HimuraInject } from 'himura';
import { DataDelegate } from '../../../../services/DataDelegate/data.delegate';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../../configs/config.common';
import { AxiosPromise } from '../../../../utils/axios.promise';

// Not Injected, save Memory
export class CouponMarketingListDelegate {

    private commonConfigs: CommonConfig = new CommonConfig();

    constructor() {
    }

    public async getList(listingType: number = 1, page: number = 1): Promise<any> {
        const couponApi = this.commonConfigs.couponService;
        const fetched: any = AxiosPromise.get(`${couponApi}/coupon/list?status=2&pageNum=1&pageSize=6`);
        if (T_T.simpleDetect(fetched)) {
            return fetched;
        } else {
            return null;
        }
    }

}
